import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/contract/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/contract',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/contract',
    method: 'put',
    data
  })
}
export function updateContractStatus(data) {
  return request({
    url: '/api/business/contract/updateContractStatus',
    method: 'post',
    data
  })
}

export function updatVoidStatus(data) {
  return request({
    url: '/api/business/contract/updatVoidStatus',
    method: 'get',
    params: data
  })
}

export function updateStatus(data) {
  return request({
    url: '/api/business/contract/updateStatus',
    method: 'get',
    params: data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/contract/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/contract',
    method: 'get',
    params: {
      id
    }
  })
}
export function getSumByContractId(id) {
  return request({
    url: '/api/business/contract/getSumByContractId',
    method: 'get',
    params: {
      id
    }
  })
}

export function copyContract(id) {
  return request({
    url: '/api/business/contract/copyContract',
    method: 'get',
    params: {
      id
    }
  })
}
